export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7000.37aa4bba.jpg";